<template>
  <base-content>
    <template v-if="loaded">
      <template slot="top">
        <hero-header centered :heading="`Withdraw funds from your ${account.name.toLowerCase()}`" />
      </template>
      <div class="row justify-content-center">
        <div class="col-sm-12 col-md-6">
          <form @submit.prevent="submit">
            <base-card>
              <base-field
                addon-left-icon="pound-sign"
                label="Enter the amount you wish to withdraw your account"
                label-class="font-weight-bold"
                mandatory
              >
                <base-input
                  v-model="amount"
                  large
                  numeric
                  placeholder="amount"
                />
              </base-field>
              <base-field label="Select bank account you wish to withdraw funds into" mandatory>
                <base-select
                  v-model="bank"
                  large
                  :model="bankAccounts"
                  :model-text-format="getBankText"
                  placeholder="bank account"
                  required
                />
              </base-field>
              <div class="text-right">
                <base-button icon-right="arrow-right" :loading="processing" secondary submit>
                  Request Withdrawal
                </base-button>
              </div>
            </base-card>
          </form>
        </div>
      </div>
    </template>
    <template v-else>
      <base-loader />
    </template>
  </base-content>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import HeroHeader from '@/components/HeroHeader.vue'

export default {
  components: {
    HeroHeader
  },

  metaInfo: {
    title: 'Withdraw Funds'
  },

  data: () => ({
    amount: '',
    bank: '',
    loaded: false
  }),

  async created () {
    await Promise.all([
      this.getAccount(this.$auth.user.accounts[0]._id),
      this.getBankAccounts({
        query: {
          status: 'APPROVED'
        }
      })
    ])

    this.loaded = true
  },

  computed: {
    ...mapState({
      account: store => store.core.accounts.entity,
      bankAccounts: store => store.core.bankAccounts.entities,
      processing: store => store.core.withdrawals.isCreatePending
    })
  },

  methods: {
    getBankText (bank) {
      return `${bank.bank} (${bank.iban})`
    },

    submit () {
      this.requestWithdrawal({
        account: this.account._id,
        bankAccount: this.bank,
        amount: this.amount
      })
        .then(() => {
          this.$flash.success('Your withdrawal has been requested.')

          this.refreshAuth()

          this.$router.push({
            name: 'dashboard'
          })
        })
        .catch(err => this.$flash.failure(err))
    },

    ...mapActions({
      getAccount: 'core/accounts/get',
      getBankAccounts: 'core/bank-accounts/all',
      refreshAuth: 'core/auth/refresh',
      requestWithdrawal: 'core/withdrawals/create'
    })
  }
}
</script>
